import React, { useCallback } from 'react';

import {
  Text,
  Modal,
  Button,
  WrapperFlex,
  FilePreview,
} from '@unimed-fesp/components';

import { MdFileDownload } from 'react-icons/md';

import {
  ContentWrapper,
  FileWrapper,
  FileHeader,
  FileContent,
  FileContentWrapper,
} from './styles';

import { ModalContent, ModalContentWrapper } from '../../molecules/Modal';
import LabelContainer from '../../molecules/LabelContainer';
import CustomScrollbars from '../../molecules/CustomScrollBars';

import { Badges } from '../../atoms/Badges';

import theme from '../../../styles/theme';
import { downloadFile } from '../../../utils/base64Picture';

import { TipoDocumentoEnum } from '../../../enums';

import ModalFooter from './ModalFooter';

function ModalDetalheDocumento({
  isOpen,
  onAceitar,
  onRecusar,
  onCloseModal,
  documentoPreview,
  reenviarDocumento,

  tipoDocumento,
  statusDocumento,
  idStatusLista,

  esconderBtnReenviar = false,
}) {
  const prepareBase64File = useCallback((extension, base64File) => {
    const types = {
      JPG: `data:image/jpeg;base64,${base64File}`,
      JPEG: `data:image/jpeg;base64,${base64File}`,
      PDF: `data:application/pdf;base64,${base64File}`,
      PNG: `data:image/png;base64,${base64File}`,
      TIFF: `data:image/tiff;base64,${base64File}`,
    };

    if (extension) {
      if (extension.includes('.'))
        return types[extension.split('.')[1]?.toUpperCase()];

      if (Object.keys(types).includes(extension?.toUpperCase()))
        return types[extension?.toUpperCase()];
    }
    return null;
  }, []);

  return (
    <Modal
      height={611}
      top={45}
      width={916}
      isOpen={isOpen}
      onClick={onCloseModal}
      header={
        <>
          {TipoDocumentoEnum.returnNameFormattedPorSigla[tipoDocumento]}:{' '}
          {documentoPreview.response?.nome}
        </>
      }
      footer={
        <ModalFooter
          idStatusLista={idStatusLista}
          onRecusar={onRecusar}
          onAceitar={onAceitar}
          onCancelar={onCloseModal}
          reenviarDocumento={reenviarDocumento}
          esconderBtnReenviar={esconderBtnReenviar}
        />
      }
    >
      <ModalContentWrapper height="440">
        <ModalContent
          width="100%"
          overflow="hidden"
          maxHeight="none"
          height="100%"
        >
          <WrapperFlex column fullWidth>
            <ContentWrapper>
              <LabelContainer
                font="14px Calibri Regular"
                lineHeight="2px"
                color={theme.colorGray}
                text="CPF"
              >
                <Text text={documentoPreview.response?.cpf} />
              </LabelContainer>
              <LabelContainer
                font="14px Calibri Regular"
                lineHeight="2px"
                color={theme.colorGray}
                text="Beneficiário"
              >
                <Text text={documentoPreview.response?.nome} />
              </LabelContainer>
              <LabelContainer
                font="14px Calibri Regular"
                lineHeight="2px"
                color={theme.colorGray}
                text="Grau"
              >
                <Text text={documentoPreview.response?.grauParentesco} />
              </LabelContainer>
              <LabelContainer
                font="14px Calibri Regular"
                lineHeight="2px"
                color={theme.colorGray}
                text="Modalidade"
              >
                <Text text={documentoPreview.response?.modalidade} />
              </LabelContainer>
              <LabelContainer
                font="14px Calibri Regular"
                lineHeight="2px"
                color={theme.colorGray}
                text="Movimentação"
              >
                <Text text={documentoPreview.response?.tipoMovimentacao} />
              </LabelContainer>
            </ContentWrapper>
            {statusDocumento === 'Recusado' ||
              (statusDocumento === 'Reprovado' && (
                <>
                  <WrapperFlex justifyStart alignStart marginLeft={47}>
                    <LabelContainer
                      font="14px Calibri Regular"
                      lineHeight="2px"
                      color={theme.colorGray}
                      text="Motivo de recusa"
                    >
                      <Text
                        text={documentoPreview.response?.mensagemConferencia}
                      />
                    </LabelContainer>
                  </WrapperFlex>
                  {documentoPreview.response?.arquivoConferencia && (
                    <LabelContainer
                      font="14px Calibri Regular"
                      lineHeight="2px"
                      color={theme.colorGray}
                      text="Anexos"
                      marginLeft="52px"
                    >
                      <WrapperFlex justifyStart alignCenter>
                        <Badges
                          cursorPointer
                          onClick={() =>
                            downloadFile(
                              prepareBase64File(
                                documentoPreview.response?.documentoExtensao,
                                documentoPreview.response?.arquivoConferencia
                              ),
                              `${documentoPreview.response?.arquivoConferenciaNome}`
                            )
                          }
                        >
                          Download
                        </Badges>
                      </WrapperFlex>
                    </LabelContainer>
                  )}
                </>
              ))}
          </WrapperFlex>
          <CustomScrollbars
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={200}
            autoHeight
            autoHeightMin={0}
            autoHeightMax={500}
            thumbMinSize={30}
            universal
          >
            <FileContentWrapper>
              <FileWrapper>
                <FileHeader>
                  <Button
                    tipo="tertiary"
                    justifySpaceAround
                    alignCenter
                    onClick={() =>
                      downloadFile(
                        prepareBase64File(
                          documentoPreview.response?.documentoExtensao,
                          documentoPreview.response?.documento
                        ),
                        `${documentoPreview.response?.cpf}_${tipoDocumento}`
                      )
                    }
                    font="16px unimed_slabregular"
                    background="rgba(242,242,242,1)"
                  >
                    <MdFileDownload />
                    download
                  </Button>
                </FileHeader>
                <FileContent>
                  <FilePreview
                    extension={`.${documentoPreview.response?.documentoExtensao}`}
                    base64={prepareBase64File(
                      documentoPreview.response?.documentoExtensao,
                      documentoPreview.response?.documento
                    )}
                  />
                </FileContent>
              </FileWrapper>
            </FileContentWrapper>
          </CustomScrollbars>
        </ModalContent>
      </ModalContentWrapper>
    </Modal>
  );
}

export default ModalDetalheDocumento;
